import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import EntryScheduleBlock from './EntryScheduleBlock';

export default class EntrySchedule extends Component {
  render() {
    return (
      <div>
        <h1 style={{ paddingBottom: '20px' }}>Scheduled Articles</h1>
        <Row>
          <Col md={4}>
            <EntryScheduleBlock platform="yt" alreadyRan="false" />
          </Col>
          <Col md={4}>
            <EntryScheduleBlock platform="fb" alreadyRan="false" />
          </Col>
          <Col md={4}>
            <EntryScheduleBlock platform="twitter" alreadyRan="false" />
          </Col>
        </Row>
        <h1 style={{ paddingBottom: '20px' }}>Past Articles</h1>
        <Row>
          <Col md={4}>
            <EntryScheduleBlock platform="yt" alreadyRan="true" />
          </Col>
          <Col md={4}>
            <EntryScheduleBlock platform="fb" alreadyRan="true" />
          </Col>
          <Col md={4}>
            <EntryScheduleBlock platform="twitter" alreadyRan="true" />
          </Col>
        </Row>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/cms/entry/EntrySchedule.js